export const LEGACY_PAGE_INSET_BLOCK_START = '56px';
